import { render, staticRenderFns } from "./form-steps.vue?vue&type=template&id=2dec3784&"
import script from "./form-steps.vue?vue&type=script&lang=js&"
export * from "./form-steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/form-steps.vue
// module id = 181
// module chunks = 0